"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallChoiceGroup = exports.StyledStack = exports.Dot = exports.ChoiceContent = exports.StyledChoice = exports.PostalCodeInput = exports.CheckoutInput = exports.SignActionsWrap = exports.SignInLink = exports.SignInWrap = exports.GridSplit = exports.SubmitNext = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const SubmitBtn = (0, app_1.styled)(ui_1.Submit) `
  width: fit-content;
  min-width: 0;
  margin-left: auto;
`;
const SubmitStack = (0, app_1.styled)(ui_1.Stack) `
  align-items: flex-end;
`;
const SubmitInfo = app_1.styled.span `
  color: ${(theme) => theme.colors.gray};
  font-size: 0.875rem;
`;
function SubmitNext() {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(SubmitStack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(SubmitBtn, { children: t('label.next') }), (0, jsx_runtime_1.jsx)(SubmitInfo, { children: t('label.nextDescription') })] })));
}
exports.SubmitNext = SubmitNext;
exports.GridSplit = (0, app_1.styled)(ui_1.Grid) `
  display: grid;
  grid-gap: 1rem;
  @media ${app_1.notDesktop} {
    grid-template-rows: repeat(2, minmax(0, 1fr));
    grid-template-columns: 1fr;
  }
`;
exports.SignInWrap = app_1.styled.span `
  font-size: 0.8125rem;
  letter-spacing: 0.025rem;
`;
exports.SignInLink = (0, app_1.styled)(app_1.Link) `
  text-decoration: underline !important;
  font-family: inherit;
  letter-spacing: inherit;
  font-size: inherit;
`;
exports.SignActionsWrap = (0, app_1.styled)(ui_1.Stack) `
  justify-content: space-between;
  @media ${app_1.notDesktop} {
    flex-direction: column;
    gap: 1rem;
  }
`;
function CheckoutInput(_a) {
    var { name } = _a, props = __rest(_a, ["name"]);
    return (0, jsx_runtime_1.jsx)(ui_1.TextInput, Object.assign({ name: name }, props));
}
exports.CheckoutInput = CheckoutInput;
exports.PostalCodeInput = (0, app_1.styled)(CheckoutInput) `
  width: 50%;
`;
exports.StyledChoice = (0, app_1.styled)(ui_1.ChoiceInput.Option) `
  &[aria-checked] {
    border: 1px solid ${(theme) => theme.stroke};
    .dot {
      box-shadow: inset 0px 0px 0px 0.35rem #3751ff;
    }
  }
`;
exports.ChoiceContent = (0, app_1.styled)(ui_1.Stack) `
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
exports.Dot = app_1.styled.div `
  height: 1.25rem;
  width: 1.25rem;
  border: 1px solid ${(theme) => theme.stroke};
  border-radius: 9999px;
`;
exports.StyledStack = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
exports.SmallChoiceGroup = (0, app_1.styled)(ui_1.ChoiceInput) `
  padding: 0;
  gap: 1rem;
`;
